import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import { DefaultTooltip } from "../../../../../../../components/Generic/Tooltip";
import { DespatchProduct } from "../../../../../../../models/despatch";
import useStyles, { NumberRowInput, RowInputDiv } from "../styles";

interface Props {
  value: number;
  row: DespatchProduct;
  attribute: keyof DespatchProduct;
  disabled: boolean;
  handleChange: (value: number, productId: number, attribute: keyof DespatchProduct) => void;
}

const QuantityInput = (props: Props) => {
  const { value, row, attribute, disabled, handleChange } = props;
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const [valueWithError, setValueWithError] = useState<number>();
  const [open, setOpen] = useState<boolean>(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    if (valueWithError) setOpen(true);
  };

  const onHandleChange = (value?: number) => {
    if (value && row?.quantityOnHand && value > row?.quantityOnHand) {
      setValueWithError(value);
    } else {
      setValueWithError(undefined);
      handleChange(Number(value), row.productId, attribute);
    }
  };

  return (
    <DefaultTooltip
      classes={{ tooltip: classes.tooltipError }}
      placement="top"
      title={`${translate("maxValueAccepted")}: ${row?.quantityOnHand || 0}`}
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -13],
            },
          },
        ],
      }}
    >
      <RowInputDiv>
        <NumberRowInput
          data-cy={`quantity-input-${attribute}`}
          type="number"
          min="0"
          max={row?.quantityOnHand}
          value={valueWithError ? String(valueWithError) : String(value)}
          disabled={disabled}
          onChange={(event) => {
            onHandleChange(Number(event.target.value));
          }}
          error={!!valueWithError}
        />
      </RowInputDiv>
    </DefaultTooltip>
  );
};

export default QuantityInput;
